import { createContext, useState, useEffect } from "react";

/* =========================
   CREATE CONTEXT
========================= */
export const WellContext = createContext();

/* =========================
   PROVIDER
========================= */
export const WellProvider = ({ children }) => {

  /* =========================
     GLOBAL WELL DATA
  ========================== */
  const [wellData, setWellData] = useState(() => {

    const saved =
      localStorage.getItem("wellData");

    return saved
      ? JSON.parse(saved)
      : {};

  });

  useEffect(() => {

    localStorage.setItem(
      "wellData",
      JSON.stringify(wellData)
    );

  }, [wellData]);

  /* =========================
     VALVES STATE
  ========================== */
  const [valves, setValves] = useState(() => {

    const saved =
      localStorage.getItem("global_valves");

    return saved
      ? JSON.parse(saved)
      : {

          XV_1001: false,
          XV_1002: false,
          FCV_1001: false,

          XV_1301: false,
          XV_1305: false,
          XV_13015: false,
          XV_13017: false,

          XV_1308: false,
          XV_1304: false,
          XV_13020: false,
          XV_13016: false,

          XV_1302: false,
          XV_1306: false,
          XV_13014: false,
          XV_13018: false,

          XV_1303: false,
          XV_1307: false,
          XV_13013: false,
          XV_13019: false,
        };

  });

  useEffect(() => {

    localStorage.setItem(
      "global_valves",
      JSON.stringify(valves)
    );

  }, [valves]);

  /* =========================
     LEVELS
  ========================== */
  const [levels, setLevels] = useState(() => {

    const saved =
      localStorage.getItem("levels");

    return saved
      ? JSON.parse(saved)
      : {};

  });

  useEffect(() => {

    localStorage.setItem(
      "levels",
      JSON.stringify(levels)
    );

  }, [levels]);

  /* =========================
     TRANSMITTERS
  ========================== */
  const [transmitters, setTransmitters] = useState(() => {

    const saved =
      localStorage.getItem("global_transmitters");

    return saved
      ? JSON.parse(saved)
      : {

          /* =========================
             INITIAL TRANSMITTERS
          ========================== */
          FIC_1001: 0,
          FIC_1201: 0,
          FIC_1104: 0,
          FIC_1302: 0,
          FIC_13011: 0,
          FIC_13010: 0,
          FIC_13012: 0,
          FIC_13013: 0,
          MarineTerminalCrudeTank2_1304: 0,
          MarineTerminalCrudeTank2_1303: 0,
          PipelineImportCrudeTank2_1303: 0,
          PipelineImportCrudeTank2_1304: 0,
          LoadingGantryCrudeTank2_1303: 0,
          LoadingGantryCrudeTank2_1304: 0,

        };

  });

  /* =========================
     SAVE TRANSMITTERS
  ========================== */
  useEffect(() => {

    localStorage.setItem(
      "global_transmitters",
      JSON.stringify(transmitters)
    );

  }, [transmitters]);

  /* =========================
     UPDATE TRANSMITTER
  ========================== */
  const updateTransmitter = (tag, value) => {

    setTransmitters(prev => ({
      ...prev,
      [tag]: value
    }));

  };

  /* =========================
     UPDATE WELL DATA
  ========================== */
  const updateData = (label, newData) => {

    setWellData(prev => ({
      ...prev,

      [label]: {
        ...prev[label],
        ...newData
      }

    }));

  };

  /* =========================
     TOGGLE VALVE
  ========================== */
  const toggleValve = (tag) => {

    setValves(prev => ({
      ...prev,
      [tag]: !prev[tag]
    }));

  };

  /* =========================
     UPDATE LEVELS
  ========================== */
  const updateLevel = (tag, value) => {

    setLevels(prev => ({
      ...prev,
      [tag]: value
    }));

  };

  /* =========================
     CONTEXT VALUES
  ========================== */
  return (

    <WellContext.Provider
      value={{

        /* =========================
           WELL DATA
        ========================== */
        wellData,
        updateData,

        /* =========================
           VALVES
        ========================== */
        valves,
        setValves,
        toggleValve,

        /* =========================
           LEVELS
        ========================== */
        levels,
        setLevels,
        updateLevel,

        /* =========================
           TRANSMITTERS
        ========================== */
        transmitters,
        setTransmitters,
        updateTransmitter,

      }}
    >

      {children}

    </WellContext.Provider>

  );
};